<template>
  <div>
    <div class="form-control auto-height">
      <span v-if="selectedOrganization && selectedOrganization.id">
        <span class="float-right" @click="resetSelected">
          <font-awesome-icon icon="times"/>
        </span>
        {{ $t('administration.users.create.selected_organization_label') }}:
        <span class="text-dark text-bold">
          {{ selectedOrganization.name }}
        </span>
        <hr class="mb-2 mt-2">
      </span>
      <OrganizationTreeViewItem
          class="cursor-pointer"
          :item="treeData"
          v-if="treeData.children && treeData.children.length"
          @updateSelected="updateSelected"
      ></OrganizationTreeViewItem>
      <span v-if="treeData.children && !treeData.children.length">
        {{ $t('administration.users.create.no_organizations_label') }}
      </span>
    </div>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import OrganizationTreeViewItem from '@/components/organizations/OrganizationTreeViewItem.vue';

export default {
  name: 'OrganizationTreeView',
  data: function() {
    return {
      treeData: {
        name: this.$t('administration.users.create.organization_expand_label'),
        children: []
      },
      selectedOrganization: {}
    }
  },
  props: {
    organization: Object
  },
  watch: {
    getSelectedOrganization: function (newValue, oldValue) {
      this.$emit('updatedCompany', newValue)
    },
    getClient: function () {
      this.loadItems();
    },
  },
  components: {
    OrganizationTreeViewItem
  },
  computed: {
    getClient() {
      return this.$store.state.client
    },
    getSelectedOrganization() {
      return this.selectedOrganization
    }
  },
  methods: {
    loadItems(setActive) {
      let self = this;
      piincHttp.get('organizations', { params:
        {
          tree: 1,
          per_page: 100,
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.loading = false;
        self.treeData.children.push(...response.data.items)
      }, function() {});
    },
    updateSelected(item) {
      if (item && item.id) {
        this.selectedOrganization = item
      }
    },
    resetSelected() {
      this.selectedOrganization = {}
    }
  },
  created () {
    this.loadItems()
    if (this.organization && this.organization.id) {
      this.updateSelected(this.organization)
    }
  }
}
</script>
